export const PLAN_CODES = {
  FREE: "free",
  STARTER: "starter",
  PRO: "pro",
  TEAM: "team",
  ADMIN: "admin",
};

export const PLAN_LIMITS_DISPLAY = {
  free: {
    name: "Free",
    price: "$0",
    deployments: 5,
    preflights: 5,
  },
  starter: {
    name: "Starter",
    price: "$29",
    deployments: 50,
    preflights: 60,
  },
  pro: {
    name: "Pro",
    price: "$49",
    deployments: 150,
    preflights: 180,
  },
  team: {
    name: "Team",
    price: "Contact Support",
    deployments: "Custom",
    preflights: "Custom",
  },
};

export function normalizePlanCode(plan) {
  const code = String(plan || "free").trim().toLowerCase();

  if (
    code === PLAN_CODES.FREE ||
    code === PLAN_CODES.STARTER ||
    code === PLAN_CODES.PRO ||
    code === PLAN_CODES.TEAM ||
    code === PLAN_CODES.ADMIN
  ) {
    return code;
  }

  return PLAN_CODES.FREE;
}

export function isPaidPlan(plan) {
  const code = normalizePlanCode(plan);
  return (
    code === PLAN_CODES.STARTER ||
    code === PLAN_CODES.PRO ||
    code === PLAN_CODES.TEAM ||
    code === PLAN_CODES.ADMIN
  );
}

export function hasPaidFeatureAccess(plan) {
  return isPaidPlan(plan);
}

export function canBuyDeploymentCapacityPack(plan) {
  return normalizePlanCode(plan) === PLAN_CODES.PRO;
}

export function getPlanLabel(plan) {
  const code = normalizePlanCode(plan);

  if (code === PLAN_CODES.STARTER) return "Starter plan";
  if (code === PLAN_CODES.PRO) return "Pro plan";
  if (code === PLAN_CODES.TEAM) return "Team plan";
  if (code === PLAN_CODES.ADMIN) return "Admin access";

  return "Free plan";
}

export function getLockedPlanLabel() {
  return "Starter or Pro";
}